import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogHeader,
  IconButton,
  Tooltip,
  Inline,
} from '@airbus/components-react';
import { ContentCopy } from '@mui/icons-material';
import { useState } from 'react';
import { t } from '../../../i18next';

export const DisplayDrawingDialog = ({ open, setOpen }) => {
  const [tooltip, setTooltip] = useState(t('mob.copy_clipboard'));
  const pagDrwLink = 'R:/TEAMS/NPI/Inflow/Drawings';

  const handleCopyClick = () => {
    setTooltip(t('mob.link_copied'));
    navigator.clipboard.writeText(pagDrwLink);
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogHeader>{t('mob.display_drawing')}</DialogHeader>
      <DialogContent>
        <p>{t('mob.open_location')}</p>
        <Inline align='start' alignItems='center'>
          <Typography color='tertiary' variant='medium'>
            {pagDrwLink}
          </Typography>
          <Tooltip placement='bottom' label={tooltip}>
            <IconButton onClick={handleCopyClick} variant='ghost'>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        </Inline>
      </DialogContent>
      <DialogActions>
        <Button variant='secondary' onClick={() => setOpen(false)}>
          {t('mob.close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
